"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalInvestorFormSchema = void 0;
const yup = __importStar(require("yup"));
const enums_1 = require("../contracts/enums");
const IndividualShareholder_1 = require("./IndividualShareholder");
const MAX_FILE_SIZE = 5242880; // 5MB in bytes
const validFileExtensions = ["pdf"]; // For checking extensions
const isValidFileExtension = (file) => {
    const extension = file.name.split(".").pop().toLowerCase();
    return validFileExtensions.includes(extension);
};
exports.ExternalInvestorFormSchema = IndividualShareholder_1.ShareholderFormSchema.shape({
    investorType: yup.string().default(enums_1.InvestorType.SOPHISTICATED),
    investorCertificate: yup
        .mixed()
        .required("Investor certificate is required")
        .test("is-valid-type", "Not a valid PDF type", (file) => file && file.type.toLowerCase() === "application/pdf")
        .test("is-valid-extension", "Not a valid PDF file", (file) => {
        if (!file)
            return false;
        return isValidFileExtension(file);
    })
        .test("is-valid-size", "Maximum file size allowed is 5MB", (file) => file && file.size <= MAX_FILE_SIZE),
    certificateExpiryDate: yup.date().required("Certificate expiry date is required"),
});
//# sourceMappingURL=ExternalInvestorSchema.js.map